import { format as formatDate } from 'date-fns';
import { de } from 'date-fns/locale';

export const format: typeof formatDate = (date, format, options) =>
  formatDate(date, format, { locale: de, ...options });
